import { render, staticRenderFns } from "./KlassikRadio.vue?vue&type=template&id=1aefadf8&scoped=true&"
import script from "./KlassikRadio.vue?vue&type=script&lang=js&"
export * from "./KlassikRadio.vue?vue&type=script&lang=js&"
import style1 from "./KlassikRadio.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aefadf8",
  null
  
)

export default component.exports